import api from "./api"
import {
	reTypeApplicantNotificationsConstants
}from "./constants"
import {
	defAction
}from "../../../helpers/defaultAction"

export const reTypeApplicantNotificationsActions = {
	getTypeApplicantNotificationsList,
	getTypeApplicantNotificationsPaged,
	createTypeApplicantNotification,
	deleteTypeApplicantNotification,
	updateTypeApplicantNotification,
	clear
}

function getTypeApplicantNotificationsList(values){
	const dispatchObj = {
		constants : reTypeApplicantNotificationsConstants.getList,
		service   : {
			func   : api.getList,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function getTypeApplicantNotificationsPaged(values){
	const dispatchObj = {
		constants : reTypeApplicantNotificationsConstants.getPaged,
		service   : {
			func   : api.getPaged,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function createTypeApplicantNotification(values){
	const dispatchObj = {
		constants : reTypeApplicantNotificationsConstants.create,
		service   : {
			func   : api.create,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function updateTypeApplicantNotification(values){
	const dispatchObj = {
		constants : reTypeApplicantNotificationsConstants.update,
		service   : {
			func   : api.update,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function deleteTypeApplicantNotification(values){
	const dispatchObj = {
		constants : reTypeApplicantNotificationsConstants.delete,
		service   : {
			func   : api.delete,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function clear(){
	return (dispatch) => dispatch({
		type: reTypeApplicantNotificationsConstants.clear
	})
}

export default reTypeApplicantNotificationsActions